export enum DisplayType {
  Default = 'DEFAULT',
  Message = 'MESSAGE',
  SQL = 'SQL'
}
